// skipcq: JS-W1028
import {
  isValidEventLocalDateString,
  isValidOptionalEventHttpsLink,
  normalizeOptionalEventTimeRange,
} from '../../domain/eventDefinitionValidation';

/**
 * @param {object} form
 * @param {string[]} allowedImageChoices
 * @returns {string | null} Error message or null if valid
 */
export function getEventFormSubmitError(form, allowedImageChoices) {
  const host = String(form.host ?? '').trim();
  const name = String(form.name ?? '').trim();
  const cardImage = String(form.cardImage ?? '').trim();
  const headerImage = String(form.headerImage ?? '').trim();
  if (!host) {
    return 'Please enter who is hosting the event.';
  }
  if (!name) {
    return 'Please enter an event name.';
  }
  if (!cardImage || !allowedImageChoices.includes(cardImage)) {
    return 'Choose a card image from the list, or upload one on the Event images tab.';
  }
  if (!headerImage || !allowedImageChoices.includes(headerImage)) {
    return 'Choose a header image from the list, or upload one on the Event images tab.';
  }
  const eventLocalDateTrimmed = String(form.eventLocalDate ?? '').trim();
  if (!eventLocalDateTrimmed) {
    return 'Please choose an event date.';
  }
  if (!isValidEventLocalDateString(eventLocalDateTrimmed)) {
    return 'Please enter a valid event date (YYYY-MM-DD).';
  }
  if (!String(form.eventTimezone ?? '').trim()) {
    return 'Please choose or enter a timezone.';
  }

  try {
    normalizeOptionalEventTimeRange(form.eventStartTime, form.eventEndTime);
  } catch (timeErr) {
    return timeErr?.message && typeof timeErr.message === 'string'
      ? timeErr.message
      : 'Invalid event times.';
  }

  const linkTrimmed = String(form.link ?? '').trim();
  if (!isValidOptionalEventHttpsLink(linkTrimmed)) {
    return 'Event link must be a valid https:// URL.';
  }
  return null;
}

/**
 * @param {object} form
 * @param {string} eventLocalDateTrimmed
 * @param {string} startTrimmed
 * @param {string} endTrimmed
 * @param {string} linkTrimmed
 * @returns {object}
 */
export function buildEventDefinitionPayload(
  form,
  eventLocalDateTrimmed,
  startTrimmed,
  endTrimmed,
  linkTrimmed,
) {
  const host = String(form.host ?? '').trim();
  const name = String(form.name ?? '').trim();
  const cardImage = String(form.cardImage ?? '').trim();
  const headerImage = String(form.headerImage ?? '').trim();
  return {
    host,
    name,
    image: cardImage,
    headerImage,
    eventLocalDate: eventLocalDateTrimmed,
    eventTimezone: String(form.eventTimezone ?? '').trim(),
    eventStartTime: startTrimmed,
    eventEndTime: endTrimmed,
    location: String(form.location ?? '').trim(),
    cityState: String(form.cityState ?? '').trim(),
    link: linkTrimmed,
    linkText: String(form.linkText ?? '').trim(),
    description: String(form.description ?? '').trim(),
    latitude: String(form.latitude ?? '').trim(),
    longitude: String(form.longitude ?? '').trim(),
  };
}
